import React from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "../../../component-lib/Molecules/button/Button";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import Table from "../../../component-lib/Organisms/table/EventEHRTable";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "436px",
    width: "850px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface ViewInventoryDialogProps {
  isOpen: boolean;
  dialogHeading: string;
  handleClose: () => void;
  defaultDataForInventoryList: any;
  groupedNotes?: any[];
}

const ViewInventoryDialog = ({
  isOpen = false,
  defaultDataForInventoryList,
  handleClose,
  dialogHeading = "Your Heading Here...",
  groupedNotes = [],
}: ViewInventoryDialogProps) => {
  // One row per filed adjustment for this item: Category | Count | Notes.
  const adjustmentColumns = [
    {
      field: "category",
      label: <div>Category</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal">{row?.type}</p>
      ),
    },
    {
      field: "count",
      label: <div>Count</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal">{row?.quantity}</p>
      ),
    },
    {
      field: "notes",
      label: <div>Notes</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal">{row?.comment || "-"}</p>
      ),
    },
  ];
  const adjustmentRows = groupedNotes?.[0]?.notes || [];
  const adjustmentItemName =
    groupedNotes?.[0]?.itemName || defaultDataForInventoryList?.itemName || "";

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          {defaultDataForInventoryList ? (
            <div
              style={{
                padding: "24px 16PX",
                display: "grid",
                gap: "24px 16px",
                gridTemplateColumns: "1fr 1fr",
                border: "1px solid #E8E8E8",
              }}
            >
              <p>
                <strong>Item Name: </strong>
                {defaultDataForInventoryList?.itemName}
              </p>
              <p>
                <strong>Category: </strong>
                {defaultDataForInventoryList?.category}
              </p>

              <p>
                <strong>Stock Level: </strong>{" "}
                {defaultDataForInventoryList?.stockLevel || ""}
              </p>
              <p>
                <strong>Reorder Point: </strong>{" "}
                {defaultDataForInventoryList?.reorderPoint || ""}
              </p>
              <p>
                <strong>Ordered Quantity: </strong>{" "}
                {defaultDataForInventoryList?.order || "0"}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                {defaultDataForInventoryList?.status || "-"}
              </p>

              <p>
                <strong>Expiration Date:</strong>{" "}
                {defaultDataForInventoryList?.expirationDate || ""}
              </p>
            </div>
          ) : (
            <p>No task data available</p>
          )}

          <div className="mt-5">
            <div className="mt-2" style={{ overflow: "auto" }}>
              <Table
                columns={adjustmentColumns}
                rows={adjustmentRows}
                noDataFoundMessage="No adjustments yet."
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="p-2">
            <Button
              // disabled={!isValid} // Button disabled if form is invalid or submitting
              label={TEXT_CONSTANTS?.CLOSE}
              variant="contained"
              onClickCb={handleClose}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                marginRight: "6px",
              }}
            ></Button>
          </div>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default ViewInventoryDialog;
